import type { OnboardingEmailTemplate } from '../OnboardingEmailModal.types';
import { ASC_350_IMPAIRMENT_TEMPLATE } from './asc350Impairment';
import { ASC_360_IMPAIRMENT_TEMPLATE } from './asc360Impairment';
import { FOLLOW_UP_DOCUMENTS_TEMPLATE } from './followUpDocuments';
import { IAS_36_GOODWILL_IMPAIRMENT_TEMPLATE } from './ias36GoodwillImpairment';
import { IAS_36_INTANGIBLE_IMPAIRMENT_TEMPLATE } from './ias36IntangibleImpairment';
import { ONBOARDING_409A_TEMPLATE } from './onboarding409a';
import { PPA_TEMPLATE } from './ppa';
import { RENEWAL_DOCUMENTS_TEMPLATE } from './renewalDocuments';

export { RENEWAL_TEMPLATE_ID } from './renewalDocuments';

// Built-in templates, one file each. The first entry is the default; templates
// with `valuationTypes` are preselected for matching Attio valuation types.
export const ONBOARDING_EMAIL_TEMPLATES: OnboardingEmailTemplate[] = [
  ONBOARDING_409A_TEMPLATE,
  FOLLOW_UP_DOCUMENTS_TEMPLATE,
  RENEWAL_DOCUMENTS_TEMPLATE,
  PPA_TEMPLATE,
  ASC_350_IMPAIRMENT_TEMPLATE,
  ASC_360_IMPAIRMENT_TEMPLATE,
  IAS_36_GOODWILL_IMPAIRMENT_TEMPLATE,
  IAS_36_INTANGIBLE_IMPAIRMENT_TEMPLATE,
];
